import { routes } from "@/services/messaging.service";
import useSWR from "swr";

import { Messaging } from "@/types/models/Messaging";
import { fetcherV2 } from "@/services/api";

export function useMessaging() {
  const { data, error, mutate } = useSWR(
    () => [routes.get, {}],
    fetcherV2<Messaging>,
    {
      revalidateIfStale: true,
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      suspense: false,
      shouldRetryOnError: false,
    }
  );

  return {
    messaging: data,
    refresh: mutate,
    isLoading: !error && !data,
    isError: error,
  };
}
